import z from 'zod';
import { customerRef, datetime, scopedEntity } from '../common';
import { reportTrigger } from './reportTrigger';
export var ReportTriggerRunReason;
(function (ReportTriggerRunReason) {
    ReportTriggerRunReason["Schedule"] = "schedule";
    ReportTriggerRunReason["Event"] = "event";
})(ReportTriggerRunReason || (ReportTriggerRunReason = {}));
export const reportTriggerChannelResult = z.object({
    success: z.boolean(),
    data: z.any().optional(),
});
export const reportTriggerRun = z.object({
    ...scopedEntity.shape,
    customer: customerRef.nullable(),
    reportTrigger,
    runReason: z.nativeEnum(ReportTriggerRunReason),
    generatedAt: datetime,
    output: z.record(z.any()),
    channelResults: reportTriggerChannelResult.array(),
});
